import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';
import BgAppDown from 'assets/img/common/bg_app_down_area.png';

import { ReactComponent as ZimssaIcon } from 'assets/img/common/ic_zimssa_white.svg';
export const Footer = styled.div`
  width: 100%;
  bottom: 0;
  display: flex;
  flex-direction: column;
`;

export const CompInfo = styled.div`
  padding: 40px 20px;
  background-color: ${palette('gray_opacity_800')};
  @media only screen and (min-width: 550px) {
    min-height: 230px;
  }
`;

export const CompInfoContainer = styled.div`
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    ${(props) => {
      return css`
        ${CompInfoWrapper} {
          &:not(:first-child) {
            margin-top: 20px;
          }
          ${TextFlexWrapper} {
            flex-direction: column;
          }
        }
      `;
    }}
  }
`;

export const CompInfoWrapper = styled.div``;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
export const IconZimssa = styled(ZimssaIcon)`
  width: 70px;
  height: 34px;
`;

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 6px;
  background: ${palette('gray_neautral_800')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AppDown = styled.div`
  min-height: 100px;
  width: 100%;
  background-color: ${palette('gray_opacity_100')};
  background-image: url('${BgAppDown}');
  background-size: cover;
  display: flex;
  align-items: center;
`;

export const AppDownContainer = styled.div`
  width: 100%;
  max-width: 940px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  @media only screen and (max-width: 550px) {
    ${(props) => {
      return css`
        ${AppDownIconWrapper} {
          display: none;
        }
        ${AppDownButtonWrapper} {
          margin-left: 50px;
        }
        ${AppDownTextWrapper} {
          ${theme('fontStyle.body2')}
        }
      `;
    }}
  }
`;

export const AppDownWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AppDownIconWrapper = styled.div`
  width: 102px;
  height: 80px;
  margin-right: 21px;
  display: block;
`;

export const AppDownTextWrapper = styled.div`
  ${theme('fontStyle.h5')}
  color: ${palette('gray_opacity_800')};
`;

export const AppDownButtonWrapper = styled.div`
  width: 80px;
  height: 32px;
`;

interface TextProps {
  color?: string;
  font?: string;
}
export const Text = styled.div<TextProps>`
  color: ${(props) =>
    props.color ? palette(props.color) : palette('white_opacity_700')};
  ${(props) =>
    props.font
      ? theme(`fontStyle.${props.font}`)
      : theme('fontStyle.subtitle')};
  &:first-child {
    margin-right: 4px;
  }
`;

interface TextWrapperProps {
  space?: string;
}

export const TextWrapper = styled.div<TextWrapperProps>`
  display: flex;
  ${(props) =>
    props.space
      ? css`
          margin-left: ${props.space}px;
        `
      : null}
`;

export const TextFlexWrapper = styled.div<TextWrapperProps>`
  display: flex;
  ${(props) =>
    props.space
      ? css`
          margin-left: ${props.space}px;
        `
      : null}
`;

export const InfoWrapper = styled.div`
  display: flex;
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const AppDownLogo = styled.img`
  width: inherit;
`;

export const AppDownButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${palette('gray_opacity_50')};
  ${theme('fontStyle.caption')}
  text-decoration: none;
  width: 100%;
  height: 36px;
  background-color: ${palette('gray_opacity_800')};
  border-radius: 8px;
  cursor: pointer;
  outline: 0;
  line-height: normal;
  padding: 1px 6px;
  text-align: center;
`;
